import { useState, useEffect } from 'react';
import { getMainStats } from '../../api/statisticAPI';

import styled from 'styled-components';

const StatsSection = () => {
  const [stats, setStats] = useState({ totalVisitors: 0, totalPosts: 0, totalConsultations: 0, totalSlides: 0, totalAnnotations: 0 });
  
  useEffect(() => {
    getMainStats().then(data => {
      setStats(data);
    });
  }, []);

  return (
    <StatsWrapper>
      <div className="container">

        <StatsGrid>
          <StatItem>
            <div className="text-box">
              <div className="count-wrapper">
                <span className="unit">{stats.totalVisitors} Visits</span>
              </div>
              <span className="label">Total Visitors</span>
            </div>
          </StatItem>

          <StatItem>
            <div className="text-box">
              <div className="count-wrapper">
                <span className="unit">{stats.totalPosts} Cases</span>
              </div>
              <span className="label">Registered Diseases</span>
            </div>
          </StatItem>
          
          <StatItem>
            <div className="text-box">
              <div className="count-wrapper">
                <span className="unit">{stats.totalConsultations} Cases</span>
              </div>
              <span className="label">Total Consultations</span>
            </div>
          </StatItem>

          <StatItem>
            <div className="text-box">
              <div className="count-wrapper">
                <span className="unit">{stats.totalSlides} Slides</span>
              </div>
              <span className="label">Total Pathology Images</span>
            </div>
          </StatItem>

          <StatItem>
            <div className="text-box">
              <div className="count-wrapper">
                <span className="unit">{stats.totalAnnotations} Marks</span>
              </div>
              <span className="label">Total Annotations</span>
            </div>
          </StatItem>
        </StatsGrid>

      </div>
    </StatsWrapper>
  );
};

const StatsWrapper = styled.section`
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  
  .container {
    padding: 68px 16px;
  }

  @media (max-width: 768px) {
    padding: 20px 0;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const StatItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-width: 200px;
  position: relative;
  padding: 0 20px;

  .text-box {
    display: flex;
    flex-direction: column;
  }

  .label {
    font-size: 15px;
    letter-spacing: 0.5px;
    align-self: center;
  }

  .count-wrapper {
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin-bottom: 8px;
  }

  .unit {
    font-size: 36px;
  }
`;

export default StatsSection;